import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'open-booking',
    templateUrl: 'open-booking.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MaterialModule
    ],
})
export class OpenBookingComponent {
    bookings: any;
    Error: string;
    NameDescription: string;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        if (Array.isArray(data)) {
            this.bookings = data;
            this.NameDescription = data["NameDescription"];
        }
        else {
            this.NameDescription = data["NameDescription"];
            this.Error = data["Message"];
        }
    }
}